export enum ActionTypes {
  SET = 'SET'
}
